import React, { useState } from "react";
import "./PreguntasTalles.css";
import { PreguntasTallesCamisas } from "./PreguntasTallesCamisas";
import { PreguntasTallesBombers } from "./PreguntasTallesBombers";
import { PreguntasTallesTops } from "./PreguntasTallesTops";

const tableOptions = {
  Camisas: PreguntasTallesCamisas,
  Bombers: PreguntasTallesBombers,
  Tops: PreguntasTallesTops,
};

export const TableComponent = () => {
  const [table, setTable] = useState("Camisas");

  const handleTableChange = (option) => {
    setTable(option);
  };

  const Table = tableOptions[table];

  return (
    <div className="preguntas-item-content-table">
      <ul>
        {Object.keys(tableOptions).map((option) => (
          <li
            key={option}
            onClick={() => handleTableChange(option)}
            className={table === option ? "active" : ""}
          >
            {option}
          </li>
        ))}
      </ul>
      <Table />
    </div>
  );
};
